import axiosClient from './axiosClient';

/**
 * Service for device-related API calls
 */
const deviceService = {
  /**
   * Get device information for logged in device
   * @returns {Promise} Device data
   */
  getMe: () => {
    return axiosClient.get(`/devices/me`);
  },

  /**
   * Use a temporary 6 digit code to login
   * @param {string} code - 6 digit code
   * @returns {Promise} Device data
   */
  login: (code) => {
    return axiosClient.post(`/devices/login`, { code });
  },

  /**
   * Clear out device token from server
   * @returns {Promise} Device data
   */
  logout: () => {
    return axiosClient.post(`/devices/logout`);
  },

  /**
   * Find a member by phone number
   * @param {string} phone - The phone number to search for
   * @returns {Promise} Member data if found
   */
  getMemberByPhone: (phone) => {
    return axiosClient.post(`/devices/member`, { phone });
  },

  /**
   * Find a member by phone number
   * @param {string} phone - The phone number to search for
   * @returns {Promise} Member data if found
   */
  addMemberByPhone: (phone) => {
    return axiosClient.post(`/devices/member-signup`, { phone });
  },

  /**
   * Find a cashier by pin
   * @param {string} pin - The pin number to use
   * @returns {Promise} Cashier (Staff) data if found
   */
  cashierLogin: (pin) => {
    return axiosClient.post(`/devices/verify-staff`, { pin });
  },

  /**
   * Create a transaction
   * @param {string} staff_pin - The cashier's pin number to use
   * @param {string} member_id - The ID of the logged in member
   * @param {float} amount - The transaction amount
   * @param {string} customer_coupon_id - (optional) The ID of the customer's coupon
   * @param {string} coupon_id - (optional) The ID of the coupon being used
   * @returns {Promise} Cashier (Staff) data if found
   */
  processTransaction: (staff_pin, member_id, amount, customer_coupon_id, coupon_id) => {
    return axiosClient.post(`/devices/transaction`, { staff_pin, member_id, amount, customer_coupon_id, coupon_id });
  },

  /**
   * Get available coupons for a member
   * @param {string} member_id - The ID of the member
   * @returns {Promise} Available coupons data
   */
  getAvailableCoupons: (member_id) => {
    return axiosClient.get(`/devices/coupons/${member_id}`);
  },

  /**
   * Resend activation SMS to a member's phone
   * @param {string} phone - The phone number to send SMS to
   * @returns {Promise} Response data
   */
  resendActivation: (phone) => {
    return axiosClient.post(`/devices/resend`, { phone });
  }

};

export default deviceService;